<template>
  <form autocomplete="off">
    <md-card>
      <md-card-header class="md-card-header-icon md-card-header-green">
        <div class="card-icon">
          <md-icon>{{ formIcon }}</md-icon>
        </div>
        <h4 class="title">{{ title }}</h4>
      </md-card-header>

      <md-card-content>
        <ValidationProvider
          name="name"
          rules="required|min:2"
          v-slot="{ passed, failed }"
        >
          <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
            <label>Naam</label>
            <md-input v-model="name" type="text"> </md-input>

            <slide-y-down-transition>
              <md-icon class="error" v-show="failed">close</md-icon>
            </slide-y-down-transition>
            <slide-y-down-transition>
              <md-icon class="success" v-show="passed">done</md-icon>
            </slide-y-down-transition>
          </md-field>
        </ValidationProvider>

        <ValidationProvider
          name="routegroups_id"
          rules="required"
          v-slot="{ passed, failed }"
        >
          <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
            <label>Groep</label>
            <md-select
              v-model="routegroups_id"
              name="routegroups_id"
              id="routegroups_id"
              required
              :disabled="requesting"
            >
              <md-option
                v-for="(group, index) in groups"
                :value="group.id"
                :key="index"
                >{{ group.name }}</md-option
              >
            </md-select>
          </md-field>
        </ValidationProvider>
        <ValidationProvider
          name="order"
          rules="required"
          v-slot="{ passed, failed }"
        >
          <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
            <label>Volgorde</label>
            <md-select
              v-model="order"
              name="order"
              id="order"
              required
              :disabled="requesting"
            >
              <md-option
                v-for="(orderOption, index) in [
                  1,
                  2,
                  3,
                  4,
                  5,
                  6,
                  7,
                  8,
                  9,
                  10,
                  11,
                  12,
                  13,
                  14,
                  15,
                  16,
                  17,
                  18,
                  19,
                  20,
                  21,
                  22,
                  23,
                  24,
                  25,
                  26,
                  27,
                  28,
                  29,
                  30,
                  31,
                  32,
                  33,
                  34,
                  35,
                  36,
                  37,
                  38,
                  39,
                  40,
                  41,
                  42,
                  43,
                  44,
                  45,
                  46,
                  47,
                  48,
                  49,
                  50,
                  51,
                  52,
                  53,
                  54,
                  55,
                  56,
                  57,
                  58,
                  59,
                  60,
                  61,
                  62,
                  63,
                  64,
                  65,
                  66,
                  67,
                  68,
                  69,
                  70,
                  71,
                  72,
                  73,
                  74,
                  75,
                  76,
                  77,
                  78,
                  79,
                  80,
                  81,
                  82,
                  83,
                  84,
                  85,
                  86,
                  87,
                  88,
                  89,
                  90,
                  91,
                  92,
                  93,
                  94,
                  95,
                  96,
                  97,
                  98,
                  99
                ]"
                :value="orderOption"
                :key="index"
                >{{ orderOption }}</md-option
              >
            </md-select>
            <slide-y-down-transition>
              <md-icon class="error" v-show="failed">close</md-icon>
            </slide-y-down-transition>
            <slide-y-down-transition>
              <md-icon class="success" v-show="passed">done</md-icon>
            </slide-y-down-transition>
          </md-field>
        </ValidationProvider>
        <ValidationProvider
          name="isreserve"
          rules="required"
          v-slot="{ passed, failed }"
        >
          <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
            <label>Route type</label>
            <md-select
              v-model="isreserve"
              name="reserve"
              id="reserve"
              required
              :disabled="requesting"
            >
              <md-option value="0">Standaard route</md-option>
              <md-option value="1">Reserve route</md-option>
            </md-select>
            <slide-y-down-transition>
              <md-icon class="error" v-show="failed">close</md-icon>
            </slide-y-down-transition>
            <slide-y-down-transition>
              <md-icon class="success" v-show="passed">done</md-icon>
            </slide-y-down-transition>
          </md-field>
        </ValidationProvider>
        <ValidationProvider
          name="color"
          rules="min:3|max:7"
          v-slot="{ passed, failed }"
        >
          <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
            <label>Kleur</label>
            <md-input
              v-model="color"
              data-vv-name="color"
              type="text"
              name="color"
              :disabled="requesting"
            >
            </md-input>
            <slide-y-down-transition>
              <md-icon class="error" v-show="failed">close</md-icon>
            </slide-y-down-transition>
            <slide-y-down-transition>
              <md-icon class="success" v-show="passed">done</md-icon>
            </slide-y-down-transition>
          </md-field>
        </ValidationProvider>
        <ValidationProvider
          name="address"
          rules="min:10"
          v-slot="{ passed, failed }"
        >
          <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
            <label>Adres</label>
            <geocoder v-model="geocoder" :value="geocoder"></geocoder>
            <slide-y-down-transition>
              <md-icon class="error" v-show="failed">close</md-icon>
            </slide-y-down-transition>
            <slide-y-down-transition>
              <md-icon class="success" v-show="passed">done</md-icon>
            </slide-y-down-transition>
          </md-field>
        </ValidationProvider>
        <span>
          <map-click-location
            v-if="geocoder.lat && geocoder.lng"
            style="height: 300px; width: 100%;"
            v-model="geocoder"
            :value="geocoder"
            marker="marker-bus.png"
          ></map-click-location>
        </span>
        <span>
          <map-routing-a-to-b
            v-if="geocoder.lat && geocoder.lng"
            style="height: 300px; width: 100%;"
            v-model="routing"
            markerA="marker-bus.png"
            markerB="marker-driver.png"
          ></map-routing-a-to-b>
        </span>
      </md-card-content>

      <md-card-actions>
        <md-button
          native-type="button"
          @click.native.prevent="goBack"
          v-bind:class="{
            'md-primary': !formTouched,
            'md-warning': formTouched
          }"
          >Terug</md-button
        >
        <md-button
          :disabled="!formTouched"
          native-type="submit"
          @click.native.prevent="validate"
          class="md-success"
          >Opslaan</md-button
        >
      </md-card-actions>
    </md-card>
  </form>
</template>
<script>
import { SlideYDownTransition } from "vue2-transitions";
import swal from "sweetalert2";
import geocoder from "../../../components/OpenStreetMap/InputGeocoder";
import MapClickLocation from "../../../components/OpenStreetMap/MapClickLocation.vue";
import MapRoutingAToB from "../../../components/OpenStreetMap/MapRoutingAToB.vue";

export default {
  components: {
    SlideYDownTransition,
    geocoder,
    MapClickLocation,
    MapRoutingAToB
  },
  data() {
    return {
      boolean: null,
      requesting: false,
      name: "",
      routegroups_id: "",
      order: "",
      isreserve: "",
      color: "",
      address: "",
      geocoder: {
        address: "",
        lat: "",
        lng: ""
      },
      routing: {
        from: {
          lat: "",
          lng: ""
        },
        to: {
          lat: "52.7015884",
          lng: "5.2878571"
        },
        distance: 0
      },
      lat: "",
      lng: "",
      groups: [],
      touched: {
        geocoder: false,
        name: false,
        routegroups_id: false,
        order: false,
        isreserve: false,
        color: false,
        address: false
      },
      submitErrors: ""
    };
  },
  methods: {
    init() {
      this.loadRoutesGroups();
      if (this.$route.params.id !== undefined) {
        this.loadRoute(this.$route.params.id);
      } else {
        this.name = "";
        this.routegroups_id = "";
        this.order = "";
        this.isreserve = "";
        this.color = "";
        this.geocoder = {
          address: "",
          lat: "",
          lng: ""
        };

        setTimeout(this.resetTouched, 100);
      }
    },
    validate() {
      this.$http
        .post(
          this.$apiBaseUrl +
            "routes/" +
            (this.$route.params.id !== undefined ? this.$route.params.id : ""),
          Object.assign({
            name: this.name,
            routegroups_id: this.routegroups_id,
            order: this.order,
            isreserve: this.isreserve,
            color: this.color,
            address: this.geocoder.address,
            lat: this.geocoder.lat,
            lng: this.geocoder.lng
          })
        )
        .then(
          response => {
            setTimeout(this.resetTouched, 100);
            this.notifyVue(
              "Route succesvol opgeslagen",
              "check",
              "success",
              5000
            );

            if (this.$route.params.id === undefined) {
              this.$router.go(-1);
            }
          },
          response => {
            if (response.status === 422) {
              let msg = "";

              this.submitErrors = response.data.errors;

              for (var i in response.data.errors) {
                for (var j in response.data.errors[i]) {
                  msg += "<br/>\n&bull;&nbsp;" + response.data.errors[i];
                }
              }

              this.notifyVue(msg, "add_alert", "danger", 0);
            } else {
              this.notifyVue(
                "Onbekende fout tijdens opslaan route",
                "report_problem",
                "danger",
                0
              );
            }
          }
        );
    },
    goBack() {
      if (!this.formTouched) {
        this.$router.go(-1);
        return;
      }

      this.showSwal();
    },
    loadRoute(id) {
      this.requesting = true;
      this.$http.get(this.$apiBaseUrl + "routes/" + id).then(
        response => {
          this.name = response.data.route.name;
          this.routegroups_id = response.data.route.routegroups_id;
          this.order = response.data.route.order;
          this.isreserve = response.data.route.isreserve;
          this.color = response.data.route.color;
          this.geocoder = {
            address: response.data.route.address,
            lat: response.data.route.lat,
            lng: response.data.route.lng
          };

          setTimeout(this.resetTouched, 100);

          this.requesting = false;
        },
        response => {
          this.requesting = false;
          if (response.status === 403) {
            // this.notifyVue("U heeft geen rechten voor het beheren van routes", 'add_alert', 'danger', 0);
          }
        }
      );
    },
    loadRoutesGroups() {
      this.requesting = true;
      this.$http.get(this.$apiBaseUrl + "routes/groups").then(
        response => {
          this.groups = response.data.routeGroups;
          this.requesting = false;
          setTimeout(this.resetTouched, 100);
        },
        response => {
          this.requesting = false;
          if (response.status === 403) {
            // this.notifyVue("U heeft geen rechten voor het beheren van routes", 'add_alert', 'danger', 0);
          }
        }
      );
    },
    resetTouched() {
      this.touched.geocoder = false;
      this.touched.name = false;
      this.touched.routegroups_id = false;
      this.touched.order = false;
      this.touched.isreserve = false;
      this.touched.color = false;
      this.touched.address = false;
      this.touched.confirmPass = false;
      this.touched.allRolesBooleans = false;
    },
    showSwal() {
      swal
        .fire({
          title: "Waarschuwing!",
          text: "Weet u zeker dat u de wijzigingen wilt negeren?",
          type: "warning",
          showCancelButton: true,
          confirmButtonText: "Ja, ga terug zonder op te slaan",
          cancelButtonText: "Annuleren",
          confirmButtonClass: "md-button md-success",
          cancelButtonClass: "md-button md-danger",
          buttonsStyling: false
        })
        .then(result => {
          if (result.value) {
            this.$router.go(-1);
          } else if (result.dismiss === swal.DismissReason.cancel) {
          }
        });
    },
    notifyVue(message, icon, type, timeout) {
      this.$notify({
        message: message,
        icon: icon,
        horizontalAlign: "center",
        verticalAlign: "top",
        type: type,
        timeout: timeout
      });
    },
    inArray(haystack, needle) {
      for (var i in haystack) {
        if (haystack[i] === needle) {
          return true;
        }
      }

      return false;
    }
  },
  watch: {
    name() {
      if (!this.requesting) {
        this.touched.name = true;
      }
    },
    routegroups_id() {
      if (!this.requesting) {
        this.touched.routegroups_id = true;
      }
    },
    order() {
      if (!this.requesting) {
        this.touched.order = true;
      }
    },
    isreserve() {
      if (!this.requesting) {
        this.touched.isreserve = true;
      }
    },
    color() {
      if (!this.requesting) {
        this.touched.color = true;
      }
    },
    address() {
      if (!this.requesting) {
        this.touched.address = true;
      }
    },
    geocoder: {
      handler(val) {
        if (!this.requesting) {
          this.touched.geocoder = true;

          this.routing.from.lat = this.geocoder.lat;
          this.routing.from.lng = this.geocoder.lng;
        }
      },
      deep: true
    },
    $route(to, from) {
      this.init();
    }
  },
  computed: {
    title: function() {
      if (this.$route.params.id !== undefined) {
        return "Route bewerken";
      }
      return "Route toevoegen";
    },
    formIcon: function() {
      if (this.requesting) {
        return "hourglass_empty";
      }
      if (this.$route.params.id !== undefined) {
        return "directions_bus";
      }
      return "directions_bus";
    },
    formTouched: function() {
      for (var i in this.touched) {
        if (this.touched[i]) {
          return true;
        }
      }

      return false;
    }
  },
  mounted() {
    this.init();
  }
};
</script>
<style lang="scss" scoped>
.md-card .md-card-actions {
  border: none;
}
</style>
